var utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		resourceRegisterKey: 'tags'
	},

	model: {
		dirtyAssignedTags: {},
		newlyAddedIndex: 0
	},

	events: {
		toggleElement: {
			type: 'click',
			action: function(event) {
				var self = event.data.component;
				var $target = $(event.target);
				var $realTarget, categoryID, categoryDataID;

				// identify categoryData element and toggle it if possible
				if(($realTarget = $target.closest('.categoryData, .category')).length > 0 && (categoryID = $realTarget.data('categoryId')) && ((categoryDataID = $realTarget.data('categoryDataId')) || (categoryDataID === null && self.model.turnedOffTagCategoryManagementGranted))) {

					// identify existing tagAssignments
					var dataIndex, existingTag, existingTagAttributes, tagFound = false;
					for(dataIndex in self.resourceData.assignedTags){
						existingTag = self.resourceData.assignedTags[dataIndex] || {};
						existingTagAttributes = existingTag.attributes || {};
						if (existingTagAttributes.categoryID === categoryID && existingTagAttributes.categoryDataID === categoryDataID) {
							tagFound = true;
							break;
						}
					}

					// identify dirty tagAssignments
					var dirtyTagID = categoryID + '_' + categoryDataID;
					var dirtyTagFound = Boolean(self.model.dirtyAssignedTags[dirtyTagID]);
					var categoryInCharge = categoryDataID === null;
					var preparedAssignedCategory = {}
					var turnedOff = false
					var turnedOn = false
					var turnedOffByInheritance = false
					if(categoryInCharge){
						if((preparedAssignedCategory = self.resourceData.preparedAssignedCategories[categoryID])){
							turnedOff = preparedAssignedCategory.turnedOff;
							turnedOn = preparedAssignedCategory.turnedOn;
							turnedOffByInheritance = preparedAssignedCategory.turnedOffByInheritance;
						} else {
							preparedAssignedCategory = {}
							turnedOffByInheritance = (self.resourceData.inheritedCategories || {})[categoryID] === false;
						}
					}

					if(tagFound) {
						if(dirtyTagFound) {
							if(categoryInCharge && ((!turnedOffByInheritance && !turnedOn) || turnedOff)) 	$realTarget.removeClass('selected dirty');
							else 																			$realTarget.addClass('selected').removeClass('dirty');
							if(categoryInCharge) 	$realTarget.removeClass('inherited')

							delete self.model.dirtyAssignedTags[dirtyTagID];
						} else {
							if(categoryInCharge && ((!turnedOffByInheritance && !turnedOn) || turnedOff)) 	$realTarget.addClass('selected dirty');
							else 																			$realTarget.removeClass('selected').addClass('dirty');
							if(categoryInCharge) 	$realTarget.addClass('inherited')

							if(categoryInCharge && turnedOff && turnedOffByInheritance) {
								$realTarget.removeClass('inherited');
								self.model.dirtyAssignedTags[dirtyTagID] = {
									type: 'update',
									id: existingTagAttributes[existingTag.primaryKey],
									categoryID: categoryID,
									categoryDataID: categoryDataID,
									relationDataIndex: dataIndex,
									primaryKey: existingTag.primaryKey,
									enabled: true
								};
							} else if(categoryInCharge && turnedOn && !turnedOffByInheritance){
								$realTarget.removeClass('inherited');
								self.model.dirtyAssignedTags[dirtyTagID] = {
									type: 'update',
									id: existingTagAttributes[existingTag.primaryKey],
									categoryID: categoryID,
									categoryDataID: categoryDataID,
									relationDataIndex: dataIndex,
									primaryKey: existingTag.primaryKey,
									enabled: false
								};
							} else {
								self.model.dirtyAssignedTags[dirtyTagID] = {
									type: 'delete',
									id: existingTagAttributes[existingTag.primaryKey],
									categoryID: categoryID,
									categoryDataID: categoryDataID,
									relationDataIndex: dataIndex,
									primaryKey: existingTag.primaryKey
								};
							}

						}
					} else {
						if(dirtyTagFound) {
							if(categoryInCharge && (!turnedOffByInheritance || turnedOff)) 	$realTarget.addClass('selected').removeClass('dirty');
							else 															$realTarget.removeClass('selected dirty');
							if(categoryInCharge) 	$realTarget.addClass('inherited')
							delete self.model.dirtyAssignedTags[dirtyTagID];
						} else {
							if(categoryInCharge && (!turnedOffByInheritance || turnedOff))	$realTarget.removeClass('selected').addClass('dirty');
							else 															$realTarget.addClass('selected dirty');
							if(categoryInCharge) 	$realTarget.removeClass('inherited')

							self.model.dirtyAssignedTags[dirtyTagID] = {
								type: 'create',
								categoryID: categoryID,
								categoryDataID: categoryDataID,
								relationDataIndex: self.resourceData.assignedTags.length + (self.model.newlyAddedIndex++),
								enabled: categoryInCharge && turnedOffByInheritance ? true : null
							};
						}
					}
				}
			}
		}
	},

	methods: {
		sanitizeResources: function(storage){
			this.model.dirtyAssignedTags = this.resourceData.dirtyAssignedTags || {};
			this.model.turnedOffTagCategoryManagementGranted = storage.user.hasAccessTo('usage:turnedOffTagCategoryManagement', this.scope)

			// estimate next available addIndex
			var d;
			for(d in this.model.dirtyAssignedTags || []){
				this.model.newlyAddedIndex = Math.max(this.model.newlyAddedIndex || 0, ((this.model.dirtyAssignedTags[d] || {}).relationDataIndex || 0) + 1);
			}
		},

		filterByName: function(name){
			var c, cd, categoryData, categoryDataAttributes;
			var nonMatchingSelectors = [];
			this.$.find('.categoryData').removeClass('nonMatching');

			if(name){
				var regexp = new RegExp(String(name).trim(), 'i');
				for(c in this.resourceData.options){
					for(cd in this.resourceData.options[c].children){
						categoryData = this.resourceData.options[c].children[cd] || {};
						categoryDataAttributes = categoryData.resources || {};
						if(String(categoryData.name || '').match(regexp) === null){
							nonMatchingSelectors.push('.categoryData[data-category-data-id="' + categoryDataAttributes.categoryDataID + '"]')
						}
					}
				}

				if(nonMatchingSelectors.length > 0){
					this.$.find(nonMatchingSelectors.join(',')).addClass('nonMatching');
				}
			}
		}
	},

	hooks: {
		onDecision: function($element, options){
			var options = {
				decisionOptions: {
					decisionType: options.decisionType,
					dirtyAssignedTags: this.model.dirtyAssignedTags
				}
			};

			if(this.config.isEnhanced !== false){
				var $enhancementComponent = $element.find('section.enhanced > [id^="c_"]').first()
				if($enhancementComponent.length > 0){
					options.enhancementComponent = getComponent($enhancementComponent)
				}
			}

			// tell tag-picker-button about the dirty resources
			this.triggerClosest('onDecision', options, 'base_form_fields_tag-picker-button');

			// close modal
			this.closest('base_modal_modal', function(modalComponent){
				modalComponent.hide()
			});
		}
	}
}